import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useOpenState } from '../hooks/useOpenState';
import { isFunction } from '../utils';
export var OpenState = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? true : _ref$isHidden,
      children = _ref.children;

  var _useState = useState(isHidden),
      _useState2 = _slicedToArray(_useState, 2),
      hidden = _useState2[0],
      setHidden = _useState2[1];

  var show = function show() {
    return setHidden(false);
  };

  var hide = function hide() {
    return setHidden(true);
  };

  return children({
    show: show,
    hide: hide,
    setHidden: setHidden,
    isHidden: hidden
  });
});
export var OpenStateContext = /*#__PURE__*/React.createContext(null);
export var OpenStateContextProvider = /*#__PURE__*/React.memo(function (_ref2) {
  var _ref2$hidden = _ref2.hidden,
      isHidden = _ref2$hidden === void 0 ? true : _ref2$hidden,
      children = _ref2.children;

  var _useOpenState = useOpenState(isHidden),
      _useOpenState2 = _slicedToArray(_useOpenState, 4),
      show = _useOpenState2[0],
      hide = _useOpenState2[1],
      setHidden = _useOpenState2[2],
      hidden = _useOpenState2[3];

  return /*#__PURE__*/React.createElement(OpenStateContext.Provider, {
    value: {
      show: show,
      hide: hide,
      setHidden: setHidden,
      hidden: hidden
    }
  }, isFunction(children) ? children({
    show: show,
    hide: hide,
    setHidden: setHidden,
    isHidden: hidden
  }) : children);
});